import { Path } from "react-native-svg";
import CustomIcon, { CustomIconProps } from "./CustomIcon";

const Info: React.FC<CustomIconProps> = (props) => (
  <CustomIcon {...props}>
    <Path clipRule="evenodd" d="M18.3334 10C18.3334 14.6024 14.6024 18.3334 10 18.3334C5.39765 18.3334 1.66669 14.6024 1.66669 10C1.66669 5.39765 5.39765 1.66669 10 1.66669C14.6024 1.66669 18.3334 5.39765 18.3334 10ZM9.16 9.835C9.16 9.37384 9.53384 9 9.995 9C10.4562 9 10.83 9.37384 10.83 9.835V13.665C10.83 14.1262 10.4562 14.5 9.995 14.5C9.53384 14.5 9.16 14.1262 9.16 13.665V9.835ZM9.99998 6.16669C9.53974 6.16669 9.16665 6.53979 9.16665 7.00003C9.16665 7.46026 9.53974 7.83336 9.99998 7.83336C10.4602 7.83336 10.8333 7.46026 10.8333 7.00003C10.8333 6.53979 10.4602 6.16669 9.99998 6.16669Z" fillRule="evenodd" /> 
  </CustomIcon>
);

export default Info;